import { apiRequest } from '../../../api/client';
import type { Task, TaskPriority, TaskSize, TaskStatus } from '../../../api/types';

// PARA-128 — атомарное создание задачи одним POST (title + size + priority).
export interface CreateTaskInput {
  title: string;
  size: TaskSize;
  priority: TaskPriority;
  // PARA-135 (AC-29, AC-30) — необязательна: backend принимает тело без поля
  // ровно как раньше, а null означает «не задано».
  estimated_duration_minutes?: number | null;
}

// PARA-128 — частичное редактирование: только изменённые поля.
export interface UpdateTaskPatch {
  title?: string;
  size?: TaskSize;
  priority?: TaskPriority;
  // PARA-135 (AC-31) — `| null` обязателен: без него явный сброс оценки
  // невыразим, а «поле отсутствует» и «поле = null» значат для сервера разное
  // (ТД-14: не менять против сбросить).
  estimated_duration_minutes?: number | null;
}

export async function fetchTasks(): Promise<Task[]> {
  return apiRequest<Task[]>('/tasks');
}

export async function fetchSubtasks(parentId: number): Promise<Task[]> {
  return apiRequest<Task[]>(`/tasks/${parentId}/subtasks`);
}

export async function createSubtask(parentId: number, title: string): Promise<Task> {
  return apiRequest<Task>(`/tasks/${parentId}/subtasks`, {
    method: 'POST',
    body: { title },
  });
}

export async function changeTaskStatus(taskId: number, status: TaskStatus): Promise<Task> {
  return apiRequest<Task>(`/tasks/${taskId}/status`, {
    method: 'PATCH',
    body: { status },
  });
}

export async function createTask(input: CreateTaskInput): Promise<Task> {
  return apiRequest<Task>('/tasks', {
    method: 'POST',
    body: input,
  });
}

export async function updateTask(taskId: number, patch: UpdateTaskPatch): Promise<Task> {
  return apiRequest<Task>(`/tasks/${taskId}`, {
    method: 'PATCH',
    body: patch,
  });
}
